import React from 'react';

import { useAddressHighlightContext } from 'lib/contexts/addressHighlight';
import { Link } from 'toolkit/chakra/link';

import { shortHash } from './format';
import Icon from './Icon';
import styles from './SabaHome.module.css';

export default function Hash({ hash, href, full = false }: { hash: string; href?: string; full?: boolean }) {
  const highlight = useAddressHighlightContext(!/^0x[\da-f]{40}$/i.test(hash));
  const [ copied, setCopied ] = React.useState(false);
  const [ failed, setFailed ] = React.useState(false);
  let copyMessage = '';
  if (copied) copyMessage = 'کپی شد';
  if (failed) copyMessage = 'کپی انجام نشد؛ آدرس را از پیوند انتخاب کنید.';
  const handleCopy = React.useCallback(async() => {
    try {
      await navigator.clipboard.writeText(hash);
      setCopied(true);
    } catch {
      setFailed(true);
    }
  }, [ hash ]);
  React.useEffect(() => {
    if (!copied && !failed) return;
    const timer = setTimeout(() => {
      setCopied(false);
      setFailed(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [ copied, failed ]);
  return (
    <span className={ `${ styles.hash } ${ full ? styles.hashFull : '' }` } data-hash={ highlight ? hash : undefined }
      onMouseEnter={ highlight?.onMouseEnter } onMouseLeave={ highlight?.onMouseLeave }
      onFocus={ highlight?.onFocus } onBlur={ highlight?.onBlur }
    >
      <Link href={ href ?? `/address/${ hash }` } title={ hash }>
        <bdi dir="ltr">{ full ? hash : shortHash(hash) }</bdi>
      </Link>
      <button
        type="button"
        title={ copyMessage || 'کپی آدرس' }
        aria-label={ copied ? 'کپی شد' : `کپی ${ hash }` }
        onClick={ handleCopy }
      >
        <Icon name={ copied ? 'check' : 'copy' } size={ 13 }/>
      </button>
      <span className={ styles.srOnly } role="status">
        { copyMessage }
      </span>
    </span>
  );
}
